import { getCatalogIcon } from '@/lib/icons';
import { cn } from '@/lib/cn';

interface Props {
  icon: string;
  hue: number;
  image?: string;
  alt?: string;
  className?: string;
  iconClassName?: string;
}

/**
 * Themed illustration used until real product images exist. If `image` is provided (real catalog),
 * it renders the photo instead — call sites need no changes.
 */
export function ProductVisual({ icon, hue, image, alt = '', className, iconClassName }: Props) {
  if (image) return <img src={image} alt={alt} loading="lazy" className={cn('h-full w-full object-cover', className)} />;
  const Icon = getCatalogIcon(icon);
  return (
    <div
      role="img" aria-label={alt || undefined} aria-hidden={alt ? undefined : true}
      className={cn('relative grid h-full w-full place-items-center overflow-hidden', className)}
      style={{ background: `linear-gradient(135deg, hsl(${hue} 85% 96%), hsl(${hue} 80% 88%))` }}
    >
      <div className="absolute -right-6 -top-6 size-28 rounded-full opacity-50" style={{ background: `hsl(${hue} 90% 92%)` }} />
      <div className="absolute -bottom-8 -left-6 size-32 rounded-full opacity-40" style={{ background: `hsl(${hue} 90% 85%)` }} />
      <Icon className={cn('relative size-1/3 max-h-24 min-h-10 min-w-10 drop-shadow-sm', iconClassName)} style={{ color: `hsl(${hue} 60% 38%)` }} strokeWidth={1.5} />
    </div>
  );
}
